import { css } from '@emotion/react';
import { colours } from '../../resources/colors';
import { breakPoints } from '../../resources/breakpoints';
import {
  fonts,
  largeHeadFontSize,
  textSize,
  uppercaseSansDisplay,
} from '../../resources/fonts';

const style = {
  artActionBox: css`
    background: ${colours.c5};
    color: ${colours.c2};
    padding: 10px;
    @media ${breakPoints.tabletPortrait} {
      padding: 15px;
    }
    @media ${breakPoints.desktopSmall} {
      padding: 20px;
    }
  `,
  originalContainer: css`
      margin-bottom: 10px;
      @media ${breakPoints.tabletPortrait} {
          margin-bottom: 15px;
      }
      @media ${breakPoints.desktopSmall} {
\          margin-bottom: 20px;
      }
    a {
      display: block;
      border-bottom: 1px solid ${colours.c2};
      padding-bottom: 10px;
      margin-bottom: 10px;
      @media ${breakPoints.tabletPortrait} {
        padding-bottom: 15px;
        margin-bottom: 15px;
      }
      @media ${breakPoints.desktopSmall} {
        padding-bottom: 20px;
        margin-bottom: 20px;
      }

      &:last-of-type {
        border-bottom: 0;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  `,
  mainActionLink: css`
    display: block;
    color: ${colours.c1};
    transition: color 0.2s ease;
    ${uppercaseSansDisplay};
    ${textSize};

    span {
      svg {
        width: 10px;
        height: 10px;
        transform: rotate(-45deg);
        fill: ${colours.c1};
        transition: fill 0.3s ease-out;
        margin-left: 3px;
      }
    }

    &:hover {
      cursor: pointer;
      color: ${colours.c1_h} svg {
        fill: ${colours.c1_h};
      }
    }
  `,
  secondaryActionLink: css`
    display: block;
    color: ${colours.c2};
    transition: color 0.2s ease;
    ${uppercaseSansDisplay};
    ${textSize};

    span {
      svg {
        width: 10px;
        height: 10px;
        transform: rotate(-45deg);
        fill: ${colours.c2};
        transition: fill 0.3s ease-out;
      }
    }

    &:hover {
      cursor: pointer;
      color: ${colours.c1};

      svg {
        fill: ${colours.c1};
      }
    }
  `,
  priceTag: css`
    display: flex;
    align-items: baseline;
    gap: 5px;
  `,
  priceFrom: css`
    font-family: ${fonts.f2};
    font-size: 0.75em;
    color: ${colours.c2};
    letter-spacing: 0.03em;
    text-transform: lowercase;
  `,
  originalPrice: css`
    display: inline-block;
    ${largeHeadFontSize};
  `,
  coloringPriceTag: css`
    & > span {
      padding-left: 5px;
    }
  `,
  sold: css`
    color: ${colours.c4};
  `,
  freeShip: css`
    display: inline-block;
    padding: 3px;
    background: ${colours.c_success};
    color: ${colours.c3};
    font-size: 0.8em;
  `,
  merchContainer: css`
    border-top: 1px solid ${colours.c4};

    margin-top: 10px;
    padding-top: 5px;
    @media ${breakPoints.tabletPortrait} {
      margin-top: 15px;
      padding-top: 10px;
    }
    @media ${breakPoints.desktopSmall} {
      margin-top: 20px;
      padding-top: 15px;
    }
  `,
  disclaimer: css`
    display: block;
    margin-top: 10px;
    font-family: ${fonts.f2};
    font-size: 0.75em;
    color: ${colours.c4};
    line-height: 1.4;
    @media ${breakPoints.tabletPortrait} {
      margin-top: 15px;
    }
    @media ${breakPoints.desktopSmall} {
      margin-top: 20px;
    }

    strong {
      color: ${colours.c2};
      font-weight: 600;
    }
  `,
  disclaimerLine: css`
    display: block;
  `,
  pricingList: css`
    display: block;
    margin: 8px 0;

    span {
      display: block;
    }
  `,
  rolloutNote: css`
    display: block;
    margin-top: 10px;
    padding: 8px 10px;
    background: ${colours.c_promo_1};
    color: ${colours.c2};
    border-left: 3px solid ${colours.c1};
    font-family: ${fonts.f2};
    font-size: 0.75em;
    line-height: 1.4;
    @media ${breakPoints.tabletPortrait} {
      margin-top: 15px;
      padding: 10px 15px;
    }
    @media ${breakPoints.desktopSmall} {
      margin-top: 20px;
      padding: 12px 20px;
    }
  `,
  merchItem: css`
    margin-bottom: 5px;

    a {
      display: block;
      color: ${colours.c2};
      transition: color 0.2s ease;
      ${uppercaseSansDisplay};
      ${textSize}

      svg {
        width: 10px;
        height: 10px;
        transform: rotate(-45deg);
        fill: ${colours.c2};
        transition: fill 0.3s ease-out;
      }

      &:hover {
        cursor: pointer;
        color: ${colours.c1};

        svg {
          fill: ${colours.c1};
        }
      }
    }

    > span {
      display: block;
    }
  `,
};

export default style;
